/** Vendors */
import axios from "axios";

/** Types */
import type { IMember, IMemberPayload, IMemberResponse } from "../types";

/* Member API Endpoints */

export async function contactMemberApi(
  props: Partial<IMember>
): Promise<IMemberResponse> {
  return await axios.put<IMemberPayload, IMemberResponse>(
    "/member/contact",
    props
  );
}

const member = {
  contact: {
    member: contactMemberApi,
  },
};

export default member;
